import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import LoginImage from '../../../assets/images/login.jpg'
import Logo from '../../../assets/images/logo/Haylo-logo-white.png'
import classNames from 'classnames'
import http from '../../../config/BaseUrl'
import { Link, useHistory } from 'react-router-dom'
const ForgotPassword = () => {

  const history = useHistory();
  const [loading, setLoading] = useState(false)
  const { register, handleSubmit, formState: { errors } } = useForm({ mode: 'all', reValidateMode: "onChange" })
  const handelForgotPassword = async (data) => {
    try {
      setLoading(true)
      await http.post('forgot', data).then((res) => {
        if (res.data.message) {
          history.push('/')
          setLoading(false)
        }
      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }
  return (
    <>
      <div className="section-authentication-login p-md-0 p-3">
        <div className="container-fluid px-0">

          <div className="row h-100">
            <div className="col-md-6 d-none d-md-block">
              <div className="page-image">
                <div className="login-header mt-5">
                  <div className="logo">
                    <img src={Logo} className="img-fluid" alt="haylo" />
                  </div>


                </div>
                <div className="image-body">
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="form-body">
                <div className="row justify-content-center align-items-end h-100">
                  <div className="col-md-7 col-sm-8 col-12">
                    <div className="mx-auto my-auto h-100">
                      <div className="p-md-3">
                        <div className="text-left">
                          <h3 className="mb-4 font-weight-bold">Forgot Password</h3>
                        </div>

                        <form onSubmit={handleSubmit(handelForgotPassword)}>
                          <div className="form-group">

                            <label htmFor="forgotEmail">Email </label>
                            <input
                              type="text"
                              id="forgotEmail"
                              className={classNames("form-control", { "is-invalid": errors.email })}
                              placeholder="Enter your email"
                              {...register('email', {
                                required: "This field is required"
                              })}
                            />
                            <span className="text-danger text-danger font-size-14">{errors.email && errors.email.message}</span>

                          </div>


                          <div className="mt-3 btn-group w-100">
                            <button type="submit" className="btn btn-primary btn-block">
                              {loading && loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
                                : ("Forgot Password")
                              }
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 pb-5">
                    <p className="pr-5 text-right font-weight-bold">Already have an account? <Link to="/">Back to login</Link></p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>

    </>
  )
}

export default ForgotPassword
